<template>
  <div class="bg_gray">
    <!-- 选择订单 -->
    <div v-if="step === 1">
      <Header navTitle="选择订单" navPath="/mobile/center/ticket"></Header>
      <div class="container bg_gray">
        <van-checkbox-group v-model="orderChecked">
          <div class="order_item" v-if="orderList.data.length > 0" v-for="(item, index) in orderList.data" :key="index"
               @click="orderCheckToggle(index)">
            <div class="check" >
              <van-checkbox :name="orderList.data[index].uuid" :ref="el => orderCheckRefs[index] = el" shape="square" icon-size="15"
                            checked-color="#52c41a" @click.stop></van-checkbox>
            </div>
            <div class="content">
              <div class="top">
                <div class="left">
                  订单编号：{{ item.order_sn }}
                </div>
                <div class="right">
                  <van-tag color="#999" text-color="#999" round plain type="primary">{{ item.type_text }}</van-tag>
                </div>
              </div>
              <div class="bottom">
                <div class="left">
                  数量：{{ item.goods_count }}
                </div>
                <div class="right">
                  实付：¥ {{ item.order_amount }}
                </div>
              </div>
            </div>
          </div>
          <van-empty v-else description="暂无内容哦~"/>
        </van-checkbox-group>
        <div style="padding:10px 15px;" v-if="orderList.data.length > 0">
          <van-button type="primary" block @click="changeTab(orderChecked)">确定</van-button>
        </div>
      </div>
    </div>
    <Overlay :isLoad="ticketLoading" :customStyle="{top: '60px'}"></Overlay>
    <!-- 申请开票 -->
    <div v-if="step === 2">
      <van-nav-bar :fixed="true"
                   z-index="10"
                   left-arrow
                   :title="applyInvoiceTitle"
                   @click-left="stepInit">
      </van-nav-bar>
      <van-form ref="applyForm" :rules="rules">
        <van-cell-group>
          <van-field label="发票类型" :rules="rules.type">
            <template #input>
              <van-radio-group v-model="form.type" direction="horizontal" @change="changeMedium">
                <van-radio name="0">普通发票</van-radio>
                <van-radio name="1">专用发票</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model="form.content"
            label="发票内容"
            readonly
          />
          <van-field
            v-model="form.money"
            label="发票金额&#160;&#160;&#160;&#160;&#160;¥"
            readonly
          />
            <!--:formatter="priceFormatter"-->
          <van-field :rules="rules.title"
                     v-model="form.title"
                     label="发票抬头"
                     :formatter="formatter1"
                     placeholder="必填"
          />
          <van-field :rules="rules.company"
                     v-model="form.company"
                     label="公司名称"
                     :formatter="formatter1"
                     placeholder="必填"
          />
          <van-field :rules="rules.taxpayer_num"
                     v-model="form.taxpayer_num"
                     label="纳税人识别号"
                     :formatter="formatter1"
                     placeholder="必填"
          />
          <van-field :rules="rules.notRequired"
            v-model="form.taxpayer_addr"
            label="纳税人地址"
            placeholder="非必填"
            :formatter="formatter1"
            v-if="form.type == 0"
          />
          <van-field :rules="rules.taxpayer_addr"
                     v-model="form.taxpayer_addr"
                     label="纳税人地址"
                     placeholder="必填"
                     :formatter="formatter1"
                     v-if="form.type == 1"
          />
          <van-field :rules="rules.notRequired"
            v-model="form.taxpayer_phone"
            label="纳税人电话"
            placeholder="非必填"
            :formatter="formatter1"
            v-if="form.type == 0"
          />
          <van-field :rules="rules.taxpayer_phone"
                     v-model="form.taxpayer_phone"
                     label="纳税人电话"
                     placeholder="必填"
                     :formatter="formatter1"
                     v-if="form.type == 1"
          />
          <van-field :rules="rules.notRequired"
            v-model="form.account_bank"
            label="开户行"
            placeholder="非必填"
            :formatter="formatter1"
            v-if="form.type == 0"
          />
          <van-field :rules="rules.account_bank"
                     v-model="form.account_bank"
                     label="开户行"
                     placeholder="必填"
                     :formatter="formatter1"
                     v-if="form.type == 1"
          />
          <van-field :rules="rules.notRequired"
            v-model="form.account_num"
            label="开户行账号"
            placeholder="非必填"
            :formatter="formatter1"
            v-if="form.type == 0"
          />
          <van-field :rules="rules.account_num"
                     v-model="form.account_num"
                     label="开户行账号"
                     placeholder="必填"
                     :formatter="formatter1"
                     v-if="form.type == 1"
          />
          <van-field
            v-model.trim="form.status_instructe"
            label="备注"
            :formatter="formatter1"
            placeholder="非必填"
          />
          <van-field label="发票介质">
            <template #input>
              <van-radio-group v-model="form.medium" direction="horizontal">
                <van-radio name="0">电子发票</van-radio>
                <van-radio name="1">纸质发票</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-if="form.medium == 0"
                     v-model="form.email_addr"
                     label="邮箱"
                     placeholder="必填"
                     :formatter="formatter1"
                     :rules="rules.email_addr"
          />
          <van-field v-if="form.medium == 1"
                     v-model="form.region"
                     is-link
                     readonly
                     name="area"
                     label="地区选择"
                     placeholder="必填"
                     @click="showRegion = true"
                     :rules="rules.region"
          />
          <van-field v-if="(form.medium == 1) " :rules="rules.post_addr"
                     v-model.trim="form.post_addr"
                     label="详细地址"
                     :formatter="formatter1"
                     placeholder="必填"
          />
          <van-field v-if="(form.medium == 1)" :rules="rules.addressee"
                     v-model.trim="form.addressee"
                     label="收件人"
                     :formatter="formatter1"
                     placeholder="必填"
          />
          <van-field v-if="(form.medium == 1)" :rules="rules.reci_phone"
                     v-model.trim="form.reci_phone"
                     label="收件人电话"
                     :formatter="formatter1"
                     placeholder="必填"
          />
        </van-cell-group>
        <div style="padding:10px 15px;">
          <van-button type="primary" block :disabled="button_sub" @click="submitForm('applyForm')">提交</van-button>
        </div>
      </van-form>
    </div>
    <!-- 弹框 -->
    <van-popup v-model:show="showRegion" position="bottom">
      <van-area
        :area-list="areaList"
        @confirm="regionConfirm"
        @cancel="showRegion = false"
      />
    </van-popup>

  </div>
</template>

<script>
  import Header from 'components/mobile/common/Header'
  import Overlay from 'components/mobile/common/Overlay'
  import {areaList} from '@vant/area-data'
  import {createInvoice, changeInvoice, checkInvoice, checkOrder} from 'api/invoice/list'
  import {getOrderList, getInvoice} from 'api/invoice/list'
  import {GetUserState, LoginUser} from 'api/user/auth/login'
  import {fmtOrderInfo} from 'api/settlement/order/admin'
  import {showMessage} from 'api/base/mobile/message'
  import {updateUserInfo, addSystemUser, GetUserInfo, mobileCheckUserInfoExist} from 'api/user/user/user'
  import {checkTrainPhone, checkEmail, checkTaxpayerNum , checkPhone} from 'utils/mobile/common'
  export default {
    components: {
      Header,
      Overlay
    },
    data() {


      let checkInputLengthRule = (value, rule) => {
        if(value.length > 63 ){
          return '请输入63个以内的字符';
        }
        let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
        if(iconRule2.test(value)){
          return "不能包含表情符号"
        }
        return true;

      }

      return {
        ticketLoading:true,
        button_sub:false,
        step: 1,
        applyInvoiceTitle:"申请开票",
        orderChecked: [],
        orderCheckRefs: [],
        areaList: areaList,
        showRegion: false,
        regionResult: '',
        uuid: '',
        value1: '',
        old_order_uuids: [],
        form: {
          id: '',
          type: '0',
          content: '培训费',
          title: '',
          money: 0,
          company: '',
          taxpayer_num: '',
          taxpayer_addr: '',
          taxpayer_phone: '',
          account_bank: '',
          account_num: '',
          post_addr: '',
          email_addr: '',
          medium: '0',
          status: '',
          status_instructe: '',
          region: '',
          order_uuids: [],
          owner_id: '',
          reci_phone: '',
          addressee:'',
          order: '',
        },
        user: {
          user_id: null,
//          cellphone: null,
        },
        is_special: true,
        rules: {
          type: [
            {required: true, message: '请选择发票类型', trigger: 'onBlur'}
          ],
          title: [
            {required: true, message: '请输入发票抬头', trigger: 'onBlur'},
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          company: [
            {required: true, message: '请输入公司名称', trigger: 'onBlur'},
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          taxpayer_num: [
            {required: true, message: '请输入纳税人识别号', trigger: 'onBlur'},
            {required: true, validator: checkTaxpayerNum, trigger: 'onBlur'}
          ],
          taxpayer_addr: [
            {required: true, message: '请输入纳税人地址', trigger: 'onBlur'},
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          taxpayer_phone: [
            {required: true, message: '请输入纳税人电话', trigger: 'onBlur'},
            {required: true, validator: checkTrainPhone, trigger: 'onBlur'},
          ],
          account_bank: [
            {required: true, message: '请输入开户行', trigger: 'onBlur'},
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          account_num: [
            {required: true, message: '请输入开户行账号', trigger: 'onBlur'},
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          medium: [
            {required: true, message: '请选择发票介质', trigger: 'onBlur'}
          ],
          email_addr: [
            {required: true, message: '请填写邮箱', trigger: 'onBlur'},
            {required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
            {required: true, validator: checkEmail, trigger: 'onBlur' },
          ],
          region: [
            {required: true, message: '请选择区域', trigger: 'onBlur'}
          ],
          post_addr: [
            {required: true, message: '请输入详细地址', trigger: 'onBlur'},
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          order: [
            {required: true, message: '请选择至少一个订单', trigger: 'onBlur'},
          ],
          notRequired: [
            { validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          addressee: [
            {required: true, message: '请输入收件人', trigger: 'onBlur'},
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          reci_phone: [
            {required: true, message: '请输入收件人电话', trigger: 'onBlur'},
            {required: true, validator: checkTrainPhone, trigger: 'onBlur'},
          ],
        },
        orderList: {
          data: [],
          selectedRows: [],
        },
        userList: {
          owner_id: '',
//          cellphone:'',
        },
        orderListNew: {
          order_sn: [],
          uuid: [],
          order: ''
        },
        fin_total_amount: ''
      }
    },
    mounted() {
      this.$emit('update:isShowHeader', false);
      if (this.$route.query.uuid != undefined) {
        this.applyInvoiceTitle = '修改开票'
        this.uuid = this.$route.query.uuid
        this.getData()
        this.change01()
      }
      else {
        this.getOwner()
      }
    },
    methods: {

      change01(){
        var order_uuids = []
        getInvoice(this.uuid).then((res) => {
            var string_uuids = res.data['order_uuids'].split(',')
            for (var i=0;i<string_uuids.length;i++){
                order_uuids.push(string_uuids[i])
            }
            this.orderChecked = order_uuids
        })
      },

      changeTab(index){
        var order_amount = 0
        var order_list = []
        var order_id = []
        var order_new = []
        if (index.length > 0) {
          for(var i=0;i<index.length;i++){
            for(var j=0;j<this.orderList.data.length;j++){
                if(this.orderList.data[j]['uuid'] == index[i]){
                  order_amount += this.orderList.data[j]['order_amount']
                  order_list.push(this.orderList.data[j]['order_sn'])
                  order_id.push(this.orderList.data[j]['uuid'])
                  order_new.push(Object.assign(this.orderList.data[j]))
                }
            }
          }
          this.form.money = order_amount.toFixed(2)
          this.orderListNew.order_sn = order_list.join(',')
          this.orderListNew.uuid = order_id.join(',')
          this.orderListNew.order = order_new
          this.step = 2
          this.form.content = '培训费'
          this.form.invoice_num = index.length
        } else {
          showMessage('请至少选择一个订单！', 'error')
        }
      },

      formatter1(value) {
        // 过滤空格
        return value.replace(/^ +| +$/g, '');
      },

      stepInit() {
        this.step = 1;
      },
      regionConfirm(value) {
        this.showRegion = false
        this.form.region = value.filter(item => !!item).map(item => item.name).join('/')
      },
      priceFormatter(value) {
        if(value.indexOf('¥') === -1) {
          const val = `¥ ${value}`
          return val
        } else {
          return value;
        }
      },
      orderCheckToggle(index) {
        this.orderCheckRefs[index].toggle();
      },
      getData() {
        getInvoice(this.uuid).then((res) => {
          let data = res.data
          let post_addr = JSON.parse(data['post_addr'])
          let post_addr_land = []
          if (data['medium'] == 1) {
            if(post_addr[0].label != null){
                post_addr_land = post_addr[0].label + '/' + post_addr[1].label + '/' + post_addr[2].label
            }else{
                post_addr_land = post_addr[0] + '/' + post_addr[1] + '/' + post_addr[2]
            }
          }

          this.old_order_uuids = data.order_uuids.split(',')
          this.form = {
            id: data.id,
            type: data.type,
            title: data.title,
            money: data.money,
            company: data.company,
            taxpayer_num: data.taxpayer_num,
            taxpayer_addr: data.taxpayer_addr,
            taxpayer_phone: data.taxpayer_phone,
            account_bank: data.account_bank,
            account_num: data.account_num,
            post_addr: post_addr[3],
            email_addr: data.email_addr,
            medium: data.medium,
            status: data.status,
            status_instructe: data.status_instructe,
            order_uuids: [],
            region: post_addr_land,
            addressee : data.addressee,
            reci_phone : data.reci_phone
          }
          this.getOwner()
        }).catch(err => {
          this.$alert(`${ err }`, '提示', {
            confirmButtonText: '确定',
          });
        });
      },
      getOrderData() {
        const that = this
        var data = {}
        if (this.uuid !== '') {
          data = {
            'owner_id': this.user.user_id,
            'select_status': '2',
            'old_order_uuids': this.old_order_uuids
          }
        } else {
          data = {
            'owner_id': this.user.user_id,
            'select_status': '2'
          }
        }
        getOrderList(data).then((res) => {

          this.ticketLoading = false

          this.orderList.data = [];
          res.data.forEach(item => {
            let filled_item = fmtOrderInfo(item);
            this.orderList.data.push(filled_item);
          });
//          that.$nextTick(() => {
//            that.orderList.data.forEach(row => {
//              if (that.old_order_uuids.indexOf(row.uuid) >= 0) {
//                that.$refs.orderList.toggleRowSelection(row, true)
//              }
//            })
//          })
        })
      },
      orderSelectChange(val) {
        this.orderList.selectedRows = val;
        this.form.order = val;
        var lengths = this.orderList.selectedRows.length;
        var uuids = this.orderList.selectedRows.map(item => {
          return item.uuid
        }).join()
        var money = this.orderList.selectedRows.map(item => {
          return item.order_amount
        })
        let total = 0
        money.forEach((value) => {
          total = total + value
        })
        const totalStr = total.toString();
        const potIndex = totalStr.indexOf('.');
        let newTotal;
        if (potIndex !== -1) {
          newTotal = totalStr.slice(0, potIndex + 3);
        } else {
          newTotal = totalStr;
        }
        this.form.money = newTotal
        this.form.order_uuids = uuids
        this.form.invoice_num = lengths
      },
      submitForm(formName) {
//        let order_uuid = this.form.order_uuids
//        let order_filters = {'uuid_in': order_uuid}
        let order_uuid = this.orderListNew.uuid

        let order_filters = {'uuid_in': order_uuid}
        this.$refs[formName].validate().then(() => {
          this.button_sub = true
          checkOrder(order_filters).then((res) => {
            if (res.result == 0) {
              let invoice_filters = {
                'new_order_uuids': order_uuid,
                'old_order_uuids': this.old_order_uuids
              }
              checkInvoice(invoice_filters).then((res) => {

                if (res.result == 1) {
                  var values = Object.assign({}, this.form)
                  if(values['medium'] == 0){
                    values['addressee'] = '';
                    values['reci_phone'] = ''
                  }

                  values['order'] = this.orderListNew.order
                  values['order_uuids'] = order_uuid
                  if (this.form.medium == 0) {
                    values['post_addr'] = []
                  } else {
                    values['post_addr'] = [this.form.region.split('/')[0],
                      this.form.region.split('/')[1],
                      this.form.region.split('/')[2],
                      this.form.post_addr]
                  }
                  if (this.uuid != '') {
                    var invoice_id = this.form.id
                    changeInvoice(invoice_id, values).then(() => {
                      this.button_sub = false
                      this.goPath('/mobile/center/ticket')
                    })
                  } else {
                    values.order_uuids = order_uuid
                    createInvoice(values).then(() => {
                      this.button_sub = false
                      this.goPath('/mobile/center/ticket')

                    })
                  }
                } else {
                  showMessage('所选订单中存在已开票订单，请刷新页面重新选择！', 'error').then(() => {
                    this.goPath('/mobile/center/ticket')
                  })
                }
              })
            } else {
              showMessage('所选订单中存在已被删除订单，请刷新页面重新选择！', 'error')
            }
          })
        }).catch(err => {});
      },
      goPath(path) {
        this.$router.push(path);
      },
      getOwner(){
        GetUserState().then((res) => {
          if (res.id) {
            this.user.user_id = res.id
            this.user.cellphone = res.cellphone
            this.user.realname = res.realname

            var owner_id = this.user.user_id
            var reci_phone = this.user.cellphone
            var addressee = this.user.realname

            this.form.owner_id = this.form.owner_id == '' ? owner_id : this.form.owner_id
            this.form.reci_phone = this.form.reci_phone == '' ? reci_phone : this.form.reci_phone
            this.form.addressee = this.form.addressee == '' ? addressee : this.form.addressee
            this.getOrderData()

            return owner_id
          }
        })
      },
      changeMedium(value){
        if (value == 1) {
          this.form.medium = '1'
        }
        if (value == 0) {
          this.form.medium = '0'
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    padding: 10px 0;
  }

  .order_item {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 15px 10px;
    margin-bottom: 10px;
    .check {
      margin-right: 10px;
    }
    .content {
      flex: 1;
      .top {
        display: flex;
        margin-bottom: 15px;
        .left {
          flex: 1;
        }
        .right {
          .van-tag {
            padding: 2px 10px;
          }
        }
      }
      .bottom {
        display: flex;
        align-items: center;
        .left {
          flex: 1;
          color: #999;
        }
        .right {
          font-size: 16px;
        }
      }
    }
  }
</style>
